import { createErrorsStore } from "@/utils/create-errors-store";

export type CardDetailsErrorsStoreValues = {
  number: string | null;
  expirationDate: string | null;
  cvv: string | null;
};

const initialErrors: CardDetailsErrorsStoreValues = {
  number: null,
  expirationDate: null,
  cvv: null,
};

export const useCardDetailsErrorsStore =
  createErrorsStore<CardDetailsErrorsStoreValues>(initialErrors);
